import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

export const loginUser = async (credentials) => {
    const response = await axios.post(
        API_ROUTES.LOGIN, credentials, { withCredentials: true }
    );
    return response.data;
};

// Extraer la llamada al backend (service)
export const logoutUser = async () => {
    await axios.post(API_ROUTES.LOGOUT, {}, { withCredentials: true });
};